import { options } from './options';
import { localization } from './localization';
import { theme } from './theme';
import { tableIcons } from './materialTableIcons';


import MaterialTable from '@material-table/core';
import { ThemeProvider } from '@material-ui/styles';
export default function DefaultMaterialTable(props) {
    return (
        <ThemeProvider theme={props.theme || theme}>
            <MaterialTable
                icons={tableIcons}
                options={options}
                localization={localization}
                {...props}
            />
        </ThemeProvider>
    );
}

export { options, localization, theme, tableIcons };
